import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { VideoGridComponent } from 'src/app/features/video/view/video-grid/video-grid.component';
import { SearchBarComponent } from "../../fragments/search-bar/search-bar.component";
import { VideoFilterComponent } from 'src/app/features/handball/video-quering/view/video-filter/video-filter.component';
import { VideoSortByComponent } from 'src/app/features/handball/video-quering/view/video-sort-by/video-sort-by.component';
import { RfebmIconButtonComponent } from "../../ui/atoms/rfebm-icon-button/rfebm-icon-button.component";
import { VideoLabService } from 'src/app/features/video/controller/video-lab.service';
import { AnalysisStore } from './store/analysis.store';

@Component({
  selector: 'app-analysis',
  templateUrl: 'analysis.component.html',
  styleUrl: 'analysis.component.scss',
  standalone: true,
  imports: [CommonModule, VideoGridComponent, SearchBarComponent, VideoFilterComponent, VideoSortByComponent, RfebmIconButtonComponent],
})
export class AnalysisComponent implements OnInit {

  readonly store = inject(AnalysisStore);

  protected showFilter: boolean = false;
  protected showSortBy: boolean = false;
  protected isInternalUser: boolean = false;

  constructor(
    private router: Router,
    private videoLabService: VideoLabService
  ) { }

  ngOnInit() {
    this.videoLabService.checkInternalAccess().subscribe(isInternal => {
      this.isInternalUser = isInternal;
    });

    this.store.hydrate();
    this.store.loadVideos();
  }

  protected onVideoDeleted(): void {
    this.store.loadVideos();
  }

  protected onUploadVideo(): void {
    this.router.navigate(['/upload']);
  }

  protected async setFilterVisible(nextState: boolean) {
    if (nextState === this.showFilter) { return; }
    if (nextState) { await this.setSortByVisible(false); }
    if (nextState) {
      document.querySelector('.filter-overlay')?.classList.remove('after-hide');
      await new Promise((resolve) => setTimeout(resolve));
    }
    this.showFilter = nextState;
    if (!nextState) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      document.querySelector('.filter-overlay')?.classList.add('after-hide');
    }
  }

  protected async setSortByVisible(nextState: boolean) {
    if (nextState === this.showSortBy) { return; }
    if (nextState) { await this.setFilterVisible(false); }
    if (nextState) {
      document.querySelector('.sortby-overlay')?.classList.remove('after-hide');
      await new Promise((resolve) => setTimeout(resolve));
    }
    this.showSortBy = nextState;
    if (!nextState) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      document.querySelector('.sortby-overlay')?.classList.add('after-hide');
    }
  }
}
